import { useT } from '_metronic/i18n/Metronici18n'
import { BrandEditModal } from '../..'
import { Button } from 'app/components/Button/Button'
import { useModal } from 'app/components/Modal/ModalContext'
import { useBrand } from '../../context/BrandContext'
import { KTCard } from '_metronic/helpers/components/KTCard'
import { KTCardBody, KTFooter } from '_metronic/helpers'

const COLOR_SWATCHES = [
  { key: 'primaryColor', label: 'Cor primária' },
  { key: 'primaryActiveColor', label: 'Cor ativa primária' },
  { key: 'asideColor', label: 'Cor do menu lateral' },
] as const

export const BrandManagementContent: React.FC = () => {
  const { t } = useT()
  const { showModal } = useModal()
  const { currentBrand } = useBrand()

  const handleEditClick = () =>
    showModal({
      title: 'Editar Configurações de Marca',
      content: <BrandEditModal brand={currentBrand} />,
    })

  return (
    <KTCard>
      <KTCardBody>
        <div className='mb-6'>
          <h4 className='mb-4 fw-bold'>Cores do site</h4>

          <div className='row g-4'>
            {COLOR_SWATCHES.map(({ key, label }) => {
              const color = currentBrand?.layout?.[key]

              return (
                <div className='col-md-4' key={key}>
                  <div className='d-flex align-items-center gap-3'>
                    <div
                      className='rounded border border-1 border-gray-300 flex-shrink-0'
                      style={{
                        backgroundColor: color || 'transparent',
                        width: '48px',
                        height: '48px',
                      }}
                    />
                    <div>
                      <small className='d-block text-muted mb-1'>{label}</small>
                      {color ? (
                        <span className='fw-semibold font-monospace text-uppercase'>{color}</span>
                      ) : (
                        <span className='fw-semibold text-muted'>Não definida</span>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        <div>
          <h4 className='mb-4 fw-bold'>Logo</h4>

          {currentBrand?.logo ? (
            <>
              <div
                className='d-flex align-items-center justify-content-center border border-1 border-gray-300 rounded p-4'
                style={{
                  width: 'fit-content',
                  backgroundColor: currentBrand.layout?.asideColor || 'var(--bs-aside-bg-color)',
                }}
              >
                <img
                  src={currentBrand.logo.url}
                  alt={`${currentBrand?.fantasia || 'Lauduzone'} logo`}
                  style={{
                    maxWidth: '220px',
                    maxHeight: '120px',
                    objectFit: 'contain',
                  }}
                />
              </div>
              <div className='text-gray-700 fs-7 mt-2'>
                Pré-visualização sobre a cor do menu lateral, como aparece no cabeçalho e na tela de
                carregamento.
              </div>
            </>
          ) : (
            <div className='text-muted fs-7'>Nenhum logo cadastrado</div>
          )}
        </div>
      </KTCardBody>
      <KTFooter className='d-flex flex-end'>
        <Button className='btn-primary' onClick={handleEditClick}>
          {t('common.edit')}
        </Button>
      </KTFooter>
    </KTCard>
  )
}
